var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(-508 -359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    d: "M2.5,0h0A2.5,2.5,0,0,1,5,2.5V15a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.5A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(508 404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_121-2",
    "data-name": "Rectangle 121",
    d: "M2.5,0h0A2.5,2.5,0,0,1,5,2.5V20a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.5A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(515 399)",
    fill: "#bf0a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_121-3",
    "data-name": "Rectangle 121",
    d: "M2.5,0h0A2.5,2.5,0,0,1,5,2.5V35a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.5A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(528 384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_121-4",
    "data-name": "Rectangle 121",
    d: "M2.5,0h0A2.5,2.5,0,0,1,5,2.5V40a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.5A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(535 379)",
    fill: "#bf0a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_121-5",
    "data-name": "Rectangle 121",
    d: "M2.5,0h0A2.5,2.5,0,0,1,5,2.5V55a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.5A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(548 364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_121-6",
    "data-name": "Rectangle 121",
    d: "M2.5,0h0A2.5,2.5,0,0,1,5,2.5V60a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.5A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(555 359)",
    fill: "#bf0a76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart5);
export default __webpack_public_path__ + "static/media/chart5.0a0d82f9dd74b4aa356aa8b5dcacdd21.svg";
export { ForwardRef as ReactComponent };